export interface WithFeatureGroup {
    readonly featureGroup: string;
}

const hasFeatureGroup = (error: unknown): error is WithFeatureGroup => {
    return !!error && typeof error === 'object' && 'featureGroup' in error;
};

export const getErrorFeatureGroup = (error: unknown) => {
    if (hasFeatureGroup(error)) {
        return error.featureGroup;
    }

    return undefined;
};
